import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { Grid, Typography } from '@material-ui/core';
import FileUploader from 'components/FileUploader';
import Button from 'components/Button';

import { importClients } from '../../store/thunk';

const ImportExample = require('../../../../assets/importacao-de-clientes.xlsx');

export default function ImportClients() {
  const dispatch = useDispatch();

  const { userId } = useSelector(state => state.profile);
  const { establishmentId } = useSelector(state => state.businessInfo);
  const { isLoading } = useSelector(state => state.advancedConfigs);

  const [params, setParams] = useState({
    file: null
  });

  const handleUploadExcel = event => {
    const file = event.target.files[0];

    if(!file) {
      return;
    }

    const isXlsxByMime = file.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    const isXlsxByName = /\.xlsx$/i.test(file.name);

    if(!isXlsxByMime && !isXlsxByName) {
      return toast.error('O formato do arquivo deve ser .xlsx');
    }

    setParams({ ...params, file });
  }

  const handleSubmit = () => {
    const { file } = params;
    dispatch(importClients(userId, establishmentId, file));
  }

  return(
    <Grid container>
      <Grid xs={12}>
        <Typography color="primary" variant="subtitle2" style={{ borderBottom: '1px solid #E4E7EA' }}>
          Importação de Clientes (Excel)
        </Typography>
      </Grid>
      <Grid xs={12}>
        <Typography variant="subtitle2" style={{ marginTop: 20 }}>
          Ao fazer a importação os clientes irão aparecer em Clientes {">"} Cadastro e Listagem {">"} Clientes.
          <br />
          <br />
          As colunas para exportação são: Nome, Email, CPF/CNPJ, CEP, Rua, Número, Complemento, Bairro, Cidade, UF, Telefone, Veículo(s), Tipo do Cliente, Dias de tolerância, Data de vencimento, Vagas, Cartões, Dias de fechamento, Data da primeira fatura, Valor da fatura e Token.
          <br />
          <br />
          As colunas obrigatórias são <b>Nome</b> e <b>Tipo do Cliente</b>, as demais poderão ficar em branco. As colunas precisam seguir a ordem apresentada. O formato do arquivo deve ser <b>.xlsx (Excel)</b>
          <br />
          <br />
          <a href={ImportExample} download='exemplo-importacao.xlsx'>
            Excel de exemplo
          </a>
        </Typography>
      </Grid>
      <Grid xs={12}>
        <Typography color="primary" variant="subtitle2" style={{ marginTop: 20, marginBottom: 20, borderBottom: '1px solid #E4E7EA' }}>
          Escolha do arquivo
        </Typography>
      </Grid>
      <Grid xs={12}>
        <FileUploader
          name="excel"
          file={params.file}
          onChange={event => handleUploadExcel(event)}
        >
          Escolher arquivo (.xlsx)
        </FileUploader>
      </Grid>
      <Grid xs={12} style={{ marginTop: 10 }}>
        <Grid container>
          <Button
            type="button"
            color="success"
            disabled={!params.file}
            loading={isLoading}
            onClick={handleSubmit}
          >
            Importar
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
}